import React, { useEffect, useState } from "react";

// Chakra imports
import {
  Box,
  Text,
  SimpleGrid,
  Alert,
  AlertIcon,
  Spinner,
  Flex,
  Button,
  Stack,
} from "@chakra-ui/react";
import Loader from "../../../../components/loader/Loader";

import Card from "components/card/Card.js";
import { SearchBar } from "components/navbar/searchBar/SearchBar";

import ProductCard from "./ProductCard";
import AddTestPurchase from "./AddTestPurchase";
import { useListContext } from "contexts/listContext";

export default function PurchaseHistory() {
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const userInfo = JSON.parse(localStorage.getItem("PAuser"));
  const isAdmin = userInfo?.message?.isAdmin || false;

  const [fetchedProducts, setFetchedProducts] = useState([]);
  const [sortedProducts, setSortedProducts] = useState([]);
  const [showAddPurchase, setShowAddPurchase] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const { list, checkedPlatforms, dateFilter } = useListContext();


  const [successAlert, setSuccessAlert] = useState('');
  const [failureAlert, setFailureAlert] = useState('');
  const [alertTimeout, setAlertTimeout] = useState(null);

  useEffect(() => {
    return () => {
      if (alertTimeout) {
        clearTimeout(alertTimeout);
      }
    };
  }, [alertTimeout]);

  const handleSuccessAlert = async (alertMessage) => {
    if (alertTimeout) {
      clearTimeout(alertTimeout);
    }
    setSuccessAlert(alertMessage);
    const timeout = setTimeout(() => {
      setSuccessAlert("");
    }, 2000);
    setAlertTimeout(timeout);
  };

  const handleFailureAlert = async (alertMessage) => {
    if (alertTimeout) {
      clearTimeout(alertTimeout);
    }
    setFailureAlert(alertMessage);
    const timeout = setTimeout(() => {
      setFailureAlert("");
    }, 2000);
    setAlertTimeout(timeout);
  };

  const fetchProducts = async () => {
    try {
      setLoading(true)
      const response = await fetch(`${backendUrl}/api/test/getTestHistory`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          uid: userInfo?.message?.result?.id,
        }),
      });

      const json = await response.json();

      if (response.ok) {
        const parsed = (json.message || []).map((item) => {
          let parsedDetails = {};
          try {
            parsedDetails = JSON.parse(item.details);
          } catch (e) {
            console.warn("Invalid JSON in details:", item.details);
          }
          return {
            ...item,
            parsedDetails,
          };
        });

        setFetchedProducts(parsed);
        setSortedProducts(parsed);
      } else {
        setError(json?.message || "Error fetching purchase history.");
      }
    } catch (e) {
      setError("Something went wrong while fetching data.");
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = async (text) => {
    try {
      if (text) {
        setSortedProducts(
          fetchedProducts.filter(({ parsedDetails }) => {
            return (
              parsedDetails &&
              (parsedDetails.title?.toLowerCase().includes(text) ||
                parsedDetails.keyword?.toLowerCase().includes(text) ||
                parsedDetails.seller_name?.toLowerCase().includes(text) ||
                parsedDetails.prod_code?.toLowerCase().includes(text))
            );
          })
        );
      } else {
        setSortedProducts(fetchedProducts);
        // handleFilter();
      }
    } catch (e) {
      console.error("error in search", e);
    }
  };

  const handleFilter = async () => {
    try {
      let keywordNames = list.map((item) => item.name?.toLowerCase());
      let platformIds = checkedPlatforms.map((item) => item.id);
      let allProducts = fetchedProducts;
      let kfilter;
      let pfilter;
      let dateSort;
      kfilter = allProducts.filter((item) =>
        keywordNames?.includes(item.parsedDetails.keyword.toLowerCase())
      );

      pfilter = kfilter.filter((item) =>
        platformIds?.includes(item.parsedDetails.platform_id)
      );

      let startDate = new Date(dateFilter.startDate);
      let endDate = new Date(dateFilter.endDate);

      dateSort = await pfilter.filter((item) => {
        let date = new Date(item.parsedDetails.date_test);
        if (date >= startDate && date <= endDate) {
          return true;
        }
      });

      setSortedProducts(dateSort);
    } catch (err) {
      console.log("error in purchaseHistory in handleFilter", err);
    }
  };

  // useEffect(() => {
  //   handleFilter();
  // }, [list, checkedPlatforms, dateFilter]);

  useEffect(() => {
    fetchProducts();
  }, [userInfo?.message?.result?.id]);

  return (
    <Box>
      {error && (
        <Alert status="error" mb={4}>
          <AlertIcon />
          {error}
        </Alert>
      )}

      {loading ? (
        <Loader/>
      ) : fetchedProducts.length === 0 ? (
        <Text>No purchase history found.</Text>
      ) : (
        <Card p="0px" w="100%">
          <Text px="20px" pt="10px">
          Count: {sortedProducts.length}
          </Text>

          <Flex
            align={{ sm: "flex-start", lg: "center" }}
            justify="space-between"
            w="100%"
            px="22px"
            py="18px"
          >
            <SearchBar
              m="10px"
              borderRadius="30px"
              onChange={(e) => handleSearch(e.target.value)}
            />
            {isAdmin && (

            <Button
              variant="action"
              alignSelf="right"
              onClick={() => setShowAddPurchase(true)}
            >
              Add Test Purchase
            </Button>
            )}
            {showAddPurchase && (
              <AddTestPurchase
                onClose={() => {
                  setShowAddPurchase(false);
                  fetchProducts();
                }}
                setSuccessAlert={setSuccessAlert}
                setFailureAlert={setFailureAlert}
              />
            )}
          </Flex>

          <SimpleGrid columns={{ base: 1 }} spacing={4}>
            {sortedProducts.map((item, index) => {
              return (
                <ProductCard
                  key={index}
                  index={index}
                  rowId={item.id}
                  details={item.parsedDetails}
                  report={item.report}
                  invoice={item.invoice}
                  fetchProducts={fetchProducts}
                  handleSuccessAlert={handleSuccessAlert}
                  handleFailureAlert={handleFailureAlert}
                  isAdmin={isAdmin}
                />
              );
            })}
          </SimpleGrid>
        </Card>
      )}

      <Stack spacing={3} position="fixed" right="10px" bottom="2vh">
        {successAlert !== "" && (
          <Alert status="success" variant="left-accent" w="40vw">
            <AlertIcon />
            {successAlert}
          </Alert>
        )}
        {failureAlert !== "" && (
          <Alert status="error" variant="left-accent" w="40vw">
            <AlertIcon />
            {failureAlert}
          </Alert>
        )}
      </Stack>
    </Box>
  );
}
